import { useUserData } from '../../../../hooks/useUserData';
import useMapModalStore from '../../../../stores/useMapModalStore';
import LighthouseModal from '../../../../ui/modals/LighthouseModal';
import type { UseLighthouseResult } from '../../useLighthouse';
import { closeMapSelectionModal } from './closeMapSelectionModal';

interface LighthouseHostProps {
  /** MapCanvas-owned lighthouse cluster (useLighthouse). Open flag from store. */
  lighthouse: UseLighthouseResult;
  walletConnected: boolean;
}

/** Lighthouse buy/sell modal (`activeModal === 'lighthouse'`). */
export default function LighthouseHost({
  lighthouse,
  walletConnected,
}: LighthouseHostProps) {
  const { data: userData } = useUserData();
  const isLighthouseModalOpen = useMapModalStore((s) => s.activeModal === 'lighthouse');

  const handleClose = () => {
    closeMapSelectionModal();
    lighthouse.setLighthouseHintOpen(false);
    lighthouse.setLighthouseSellOpen(false);
    lighthouse.setLighthouseSellPrice('');
  };

  const ownerId = lighthouse.lighthouseObject?.owner_id ?? null;
  const isOwned = ownerId !== null && ownerId !== undefined;
  const isMine = isOwned && !!userData?.user_id && String(ownerId) === String(userData.user_id);
  const owner = lighthouse.lighthouseObject?.owner ?? null;

  // priceStars must stay in sync with LIGHTHOUSE_PRICE_STARS in the backend's
  // app/services/invoice.py — the successful-payment handler validates the charged
  // amount against that constant, so a mismatch would reject real payments.
  return (
            <LighthouseModal
              isOpen={isLighthouseModalOpen}
              onClose={handleClose}
              priceStars={249}
              owner={owner}
              isOwned={isOwned}
              isMine={isMine}
              onBuy={lighthouse.handleLighthouseBuy}
              buyLoading={lighthouse.lighthouseBuyLoading}
              hintOpen={lighthouse.lighthouseHintOpen}
              onToggleHint={() => lighthouse.setLighthouseHintOpen((v) => !v)}
              listing={lighthouse.lighthouseListing}
              sellOpen={lighthouse.lighthouseSellOpen}
              onOpenSell={() => lighthouse.setLighthouseSellOpen(true)}
              sellPrice={lighthouse.lighthouseSellPrice}
              onChangeSellPrice={lighthouse.setLighthouseSellPrice}
              onList={lighthouse.handleLighthouseList}
              sellLoading={lighthouse.lighthouseSellLoading}
              onCancelListing={lighthouse.handleLighthouseCancelListing}
              rate={lighthouse.lighthouseRate}
              buyCurrency={lighthouse.lighthouseBuyCurrency}
              onSetBuyCurrency={lighthouse.setLighthouseBuyCurrency}
              onWalletBuy={lighthouse.handleLighthouseWalletBuy}
              walletBuyLoading={lighthouse.lighthouseBuyWalletLoading}
              walletConnected={walletConnected}
            />
  );
}
